import React from 'react'
import { twMerge } from 'tailwind-merge'

type FilterCountProps = {
  className?: string
  count?: number
}

const FilterCount = ({ className = '', count = 0 }: FilterCountProps) => {
  return (
    <span
      className={`font-Roboto text-10 tracking-0 ml-2 flex w-fit items-center rounded-[9px] py-[3px] px-[9px] outline-none ${twMerge(
        `bg-black text-white ${className}`
      )}`}
    >
      {count}
    </span>
  )
}

export default FilterCount
